import i18next from 'i18next';
import React from 'react';

import { AccountContainer, NameContainer, textWithEllipsis } from '../../styledComponents';

import Text, { ENUM_COLORS, ENUM_FONTS } from '../../../../Text';

/**
 * "Name / Connect" row of the account switch list, shared by the InPulse group accounts
 * and the MOS operators.
 */
const SwitchAccountItem = ({ name, onClick }) => (
  <AccountContainer onClick={onClick}>
    <NameContainer>
      <Text color={ENUM_COLORS.LIGHTEST} style={textWithEllipsis}>
        {name}
      </Text>
      <Text color={ENUM_COLORS.DGREY} font={ENUM_FONTS.TEXT_SMALL_HEIGHT_16}>
        {i18next.t('AUTHENTICATION.LOGIN.CONNECT')}
      </Text>
    </NameContainer>
  </AccountContainer>
);

export default SwitchAccountItem;
